import * as React from 'react';

import { Text } from '@components/common';

import { CellFC } from './types';

export const Default: CellFC = ({ cell }) => <Text truncate>{String(cell.value)}</Text>;
